export const globalImages = {
  hintArrow: require("./global/hint_box_arrow.png"),
  successIcon: require("./global/successIcon.svg").default,
  errorIcon: require("./global/errorIcon.svg").default,
  crossWhite: require("./closewhite.svg").default,
  esteghlalSplash: require("./esteghlalSplash.svg").default,
  evcLogoWhite: require("./EVCWhite.svg").default,
  telephone24: require("./telephone24.svg").default,
  instagram: require("./instagram.svg").default,
};

export const loginImages = {
  bgMobileShadow: require("./login/bg-shadow-mobile.svg").default,
  bgMobileShadowBottom: require("./login/bg-shadow-mobile-bottom.svg").default,
  bgDesktopBottomShadow: require("./login/desktop-bg-shadow-bottom.svg")
    .default,
  bgDesktopshadow: require("./login/desktop-bg-shadow.svg").default,
  backIcon: require("./login/backIcon.svg").default,
  logo: require("./login/EVC.svg").default,
  showPassIcon: require("./login/show_pass_icon.svg").default,
  hidePassIcon: require("./login/eye-slash.svg").default,
};

export const liveImages = {
  arrowLeft: require("./Live/arrow_left.svg").default,
  ligBartarLogo: require("./Live/ligBartar.svg").default,
  liveSampleImage: require("./Live/test_image.jpeg"),
};

export const moneyTransferImages = {
  addIcon: require("./moneyTransfer/add_icon.svg").default,
  bankIconSample: require("./moneyTransfer/bankIconSample.svg").default,
  rightArrow: require("./moneyTransfer/right_arrow.svg").default,
  leftArrow: require("./moneyTransfer/left_arrow.svg").default,
  deleteIcon: require("./moneyTransfer/trash.svg").default,
  shareIcon: require("./moneyTransfer/share_icon.svg").default,
  editIcon: require("./moneyTransfer/edit_icon.svg").default,
  searchIcon: require("./moneyTransfer/search-icon.svg").default,
  transferVector: require("./moneyTransfer/arrowIcon.svg").default,
};

export const profileImage = {
  transactionCancel: require("./profile/transaction_cancel.svg").default,
  transactionSuccess: require("./profile/transaction_success.svg").default,
  arowLrft: require("./profile/arrow-right.svg").default,
  crosssIcon: require("./profile/crossIcon.svg").default,
  crossWhite: require("./profile/crossWhite.svg").default,
  bankIcon: require("./profile/bankIcon.svg").default,
  bankIconWhite: require("./profile/bankIconWhite.svg").default,
  walletsIcon: require("./profile/wallet_icon.svg").default,
  uidIcon: require("./profile/uid.svg").default,
  scoresIcon: require("./profile/star_icon.svg").default,
  lotteryIcon: require("./profile/lottery_icon.svg").default,
  downloadIcon: require("./profile/download_app_icon.svg").default,
  scoreIcon: require("./profile/score_icon.svg").default,
  directDebitIcon: require("./profile/direct_debit_icon.svg").default,
  informationIcon: require("./profile/information_icon.svg").default,
  documnetsIcon: require("./profile/documents.svg").default,
  buySubscriptionIcon: require("./profile/buySubscription.svg").default,

  addImageIcon: require("./profile/plusIcon.svg").default,
  addBlueIcon: require("./profile/plusIconBlue.svg").default,
  addimageWhiteIcon: require("./profile/plusIconWhite.svg").default,

  successIcon: require("./profile/successIcon.svg").default,
  walletsIconWhite: require("./profile/wallet_icon_white.svg").default,
  scoreIconWhite: require("./profile/score_icon_white.svg").default,
  docsComplete: require("./profile/docs_complete_icon.svg").default,
  selectedCircle: require("./profile/selected_circle.svg").default,
  proccesing_icon: require("./profile/proccessing_icon.svg").default,
  rejectedIcon: require("./profile/close-circle.svg").default,
  lotteryAndDiscount: require("./profile/lottery_and_discount.svg").default,
  transactionHistory: require("./profile/transaction-minus.svg").default,
  completeDocumentsIcon: require("./profile/complete_info_logo.svg").default,

  lotteryAndDiscountCode: {
    scoresBannerIcon:
      require("./profile/lotteryAndDiscountCode/scores_banner_icon.svg")
        .default,
    lotteryBannerIcon:
      require("./profile/lotteryAndDiscountCode/lotory_banner_icon.svg")
        .default,
    copyIcon: require("./profile/lotteryAndDiscountCode/copy.svg").default,
  },
  subscriptions: {
    basic: require("./profile/subscription/basic.svg").default,
    blue: require("./profile/subscription/blue.svg").default,
    bronze: require("./profile/subscription/bronz.svg").default,
    golden: require("./profile/subscription/golden.svg").default,
    platunium: require("./profile/subscription/platinum.svg").default,
    silver: require("./profile/subscription/silver.svg").default,
  },

  lottery: {
    buyCardDesign: require("./profile/lottery/card.svg").default,
    starIcon: require("./profile/lottery/star.svg").default,
    throneIcon: require("./profile/lottery/throne.svg").default,
  },
};

export const topBarImages = {
  searchBlue: require("./topBar/searchIconBlue.svg").default,
  searchWhite: require("./topBar/searchIconWhite.svg").default,

  tvDesktop: require("./topBar/tvDesktop.svg").default,
  tvDesktopBlue: require("./topBar/tvDesktopBlue.svg").default,
  tvHoverBlue: require("./topBar/tvHoverBlue.svg").default,
  tvHoverWhite: require("./topBar/tvHoverWhite.svg").default,

  financierDesktop: require("./topBar/financierDesktopLogo.svg").default,
  financierDesktopBlue: require("./topBar/financierDesktopLogoBlue.svg")
    .default,
  financierHoverBlue: require("./topBar/financierHoverBlue.svg").default,
  financierHoverWhite: require("./topBar/financierHoverWhite.svg").default,

  cardDesktop: require("./topBar/cardDesktopLogo.svg").default,
  cardDesktopBlue: require("./topBar/cardDesktopLogoBlue.svg").default,
  cardHoverBlue: require("./topBar/cardHoverBlue.svg").default,
  cardHoverWhite: require("./topBar/cardHoverWhite.svg").default,

  logoWhite: require("./topBar/logoWhite.svg").default,
  logo: require("./topBar/logo.svg").default,

  filter: require("./topBar/filter.svg").default,
  filterBlue: require("./topBar/filterBlue.svg").default,

  back: require("./topBar/back.svg").default,
  backBlue: require("./topBar/backBlue.svg").default,
  backLeft: require("./topBar/backLeft.svg").default,

  profileLoggedIn: require("./topBar/profileLoggedIn.svg").default,
  profileLoggedInWhite: require("./topBar/profileLoggedInWhite.svg").default,
  profileNotLoggedInWhite: require("./topBar/profileNotLoggedInWhite.svg")
    .default,
  profileNotLoggedIn: require("./topBar/userNotLoggedIn.svg").default,

  desktopHomeIcon: require("./topBar/homeIcon.svg").default,
  desktopHomeIconBlue: require("./topBar/homeIconBlue.svg").default,
  homeIconHoverBlue: require("./topBar/homeIconHoverBlue.svg").default,
  homeIconHoverWhite: require("./topBar/homeIconWhite.svg").default,

  logout: require("./topBar/logout.svg").default,

  referallCode: require("./topBar/refferal_icon.svg").default,
  referallCodeWhite: require("./topBar/refferal_icon_white.svg").default,
  referallCodeGrey: require("./topBar/refferal_icon_gray.svg").default,
};

export const toastIamges = {
  cancel: require("./toast/cancel_icon.svg").default,
  cancelError: require("./toast/cancel_error_icon.svg").default,
  cancelWarning: require("./toast/cancel_warning_icon.svg").default,
  cancelSuccess: require("./toast/cancel_success_icon.svg").default,
  cancelHint: require("./toast/cancel_hint.svg").default,
  errorIcon: require("./toast/error_icon.svg").default,
  warnigIcon: require("./toast/warning_icon.svg").default,
  successIcon: require("./toast/success_icon.svg").default,
};

export const rightel = {
  banner: require("./rightel/banner.svg").default,
  swiperSampleImage: require("./rightel/swiper_item_image.svg").default,
  warnigIcon: require("./rightel/warning_icon.svg").default,
  internetIcon: require("./rightel/internet_icon.svg").default,
  callIcon: require("./rightel/phone_icon.svg").default,
  smsIcon: require("./rightel/sms_icon.svg").default,
  deliverIcon: require("./rightel/deliver_icon.svg").default,
  rightelIcon: require("./rightel/rightelIcon.svg").default,
  searchIcon: require("./rightel/searchIcon.svg").default,
  checkmark: require("./rightel/checkMark.svg").default,
  refreshIcon: require("./rightel/refresh_icon.svg").default,
  userIcon: require("./rightel/user_icon.svg").default,
  bellIcon: require("./rightel/bell_icon.svg").default,
  billIcon: require("./rightel/bill_icon.svg").default,
  paymentSuccessIcon: require("./rightel/payment_success_icon.svg").default,
  errorIcon: require("./rightel/error_icon.svg").default,
  checkAndPay: {
    simcardIcon: require("./rightel/result_simcard.svg").default,
    productName: require("./rightel/result_purchase.svg").default,
    productPrice: require("./rightel/result_payment.svg").default,
    trasport: require("./rightel/result_transport.svg").default,
    tax: require("./rightel/result_tax.svg").default,
    paymentGateWay: require("./rightel/result_payment_gateway.svg").default,
  },
};

export const entertainment = {
  footballstar1: require("./entertainment/footbal1.svg").default,
  footballstar2: require("./entertainment/football2.svg").default,

  bannerLogo: require("./entertainment/footbal_icon.svg").default,
};

export const storeImages = {
  samsung: require("./store/samsung.svg").default,
  mapLogo: require("./store/mapLogo.svg").default,
  mapDesktopLogo: require("./store/LocationDesktopLogo.svg").default,
  siteLogo: require("./store/siteLogo.svg").default,
  siteDesktopLogo: require("./store/siteDesktopLogo.svg").default,
  violationLogo: require("./store/takhaloph.svg").default,
  violationDesktopLogo: require("./store/takhalophDesktopLogo.svg").default,
  supportLogo: require("./store/supportLogo.svg").default,
  supportDesktopLogo: require("./store/supportDesktopLogo.svg").default,
  callLogo: require("./store/callLogo.svg").default,
  callDesktopLogo: require("./store/supportDesktopLogo.svg").default,
  scannerLogo: require("./store/scannerLogo.svg").default,
  violationReport: require("./store/violationReport.svg").default,
  arrowRight: require("./store/arrow-right.svg").default,
};

export const navbarImages = {
  home: require("./navbarImg/home.svg").default,
  merchant: require("./navbarImg/building.svg").default,
  loan: require("./navbarImg/loan.svg").default,
  sport: require("./navbarImg/sport.svg").default,
  wallet: require("./navbarImg/wallet.svg").default,
  refferal: require("./navbarImg/referral.svg").default,
};

export const charge = {
  simCard: require("./services/charge/simcard.svg").default,
  blueSimcard: require("./services/charge/simcardBlue.svg").default,
  contact: require("./services/charge/contact.svg").default,
  blueContact: require("./services/charge/contactBlue.svg").default,
  checkmark: require("./services/charge/checkmark.svg").default,
};

export const homeImages = {
  chargeIcon: require("../img/home/charge_icon.svg").default,
  internetIcon: require("../img/home/internetIcon.svg").default,
  billIcon: require("../img/home/bill_icon.svg").default,
  carIcon: require("../img/home/naja_icon.svg").default,

  creditIcon: require("../img/home/credit.svg").default,
  filmIcon: require("../img/home/movie_icon.svg").default,
  investmentIcon: require("../img/home/investment.svg").default,
  healthIcon: require("../img/home/health_icon.svg").default,
  insuranceIcon: require("../img/home/insurance.svg").default,
  intertainmentIcon: require("../img/home/intertainment.svg").default,
  rightelIcon: require("../img/home/rightel.svg").default,
  lifeStyleIcon: require("../img/home/life_style.svg").default,
  tourismIcon: require("../img/home/tourism.svg").default,
  footballSchoolIcon: require("../img/home/football_school.svg").default,
  kadonaIcon: require("../img/home/kadona_icon.svg").default,
  shopIcon: require("../img/home/esteghlal_shop.svg").default,
};

export const scoreImages = {
  bannerSmallImg: require("./score/moneyLogo.svg").default,
  bannerBigImg: require("./score/moneyLogoBig.svg").default,
  filterIcon: require("./score/fiterIcon.svg").default,
};

export const walletImages = {
  walletActiveIcon: require("./wallet/walletActiveIcon.svg").default,
  addMoneyIcon: require("./wallet/card-add.svg").default,
  getMoneyIcon: require("./wallet/card-remove.svg").default,
  filterIcon: require("./wallet/filter.svg").default,
  walletIconSample: require("./wallet/wallet_icon_sample.svg").default,
};

export const acountImages = {
  toRightArrow: require("./financier/toRightVector.svg").default,
  toLeftArrow: require("./financier/toLeftVector.svg").default,
};

export const servicesImages = {
  police: {
    violation: {
      inferacationIcon:
        require("./services/Police/violation/Infractions_icon.svg").default,
      cancelIcon: require("./services/Police/violation/cancel_icon.svg")
        .default,
      handSetIcon: require("./services/Police/violation/hand_set_icon.svg")
        .default,
      najaSetIcon: require("./services/Police/violation/naja_set_icon.svg")
        .default,

      policeCarIcon: require("./services/Police/violation/policeCarIcon.svg")
        .default,
      carIconDisable:
        require("./services/Police/violation/policeCarIconDisable.svg").default,

      motorcycleIcon: require("./services/Police/violation/motorCycleIcon.svg")
        .default,
      disablemotorCycle:
        require("./services/Police/violation/disableMotorCycle.svg").default,

      iranFlag: require("./services/Police/violation/flag_icon.svg").default,
    },

    drivingLisence: {
      negativePoints:
        require("./services/Police/drivingLicense/negativePointsIcon.svg")
          .default,
      licenseCardFront:
        require("./services/Police/drivingLicense/license_card_front.svg")
          .default,
      licenseCardBack:
        require("./services/Police/drivingLicense/lisence_card_back.svg")
          .default,
      showCardsIcon:
        require("./services/Police/drivingLicense/cards_show_icon.svg").default,
      showDataIcon:
        require("./services/Police/drivingLicense/data_show_icon.svg").default,
    },

    carIcon: require("./services/Police/car.svg").default,
    hintIcon: require("./services/Police/hint_icon.svg").default,
    arrowDown: require("./services/Police/bottom_arrow.svg").default,
  },

  charge: {},
  internet: {},
  bill: {
    starterBanner: require("./services/bill/starter_banner.svg").default,
    abfazelabIcon: require("./services/bill/ab_fazelab.svg").default,
    mokhaberatIcon: require("./services/bill/mokhaberat.svg").default,
    gasIcon: require("./services/bill/gaz.svg").default,
    barghIcon: require("./services/bill/bargh.svg").default,
    hamrahAval: require("./services/bill/hamrahAval.svg").default,
    addIcon: require("./services/bill/add_icon.svg").default,
    cancelIcon: require("./services/bill/cancel_icon.svg").default,
  },
};

export const referallCodeImages = {
  addFriend: require("./referral/add_friend_icon.svg").default,
  copyIcon: require("./referral/copy_icon.svg").default,
  shareIcon: require("./referral/share_icon.svg").default,
};

export const loanImages = {
  checkmark: require("./financier/check_mark.svg").default,
  rightArrow: require("./financier/arrow-right.svg").default,
  arrowDown: require("./financier/arrow-down.svg").default,
};

export const getAppImages = {
  androidLogo: require("./getApp/android_icon.svg").default,
  webAppLogo: require("./getApp/web_icon.svg").default,
  iosLogo: require("./getApp/ios_icon.svg").default,
  googlePlayLogo: require("./getApp/google_play.svg").default,
  downloadIcon: require("./getApp/get_app_icon.svg").default,
  cafeBazarIcon: require("./getApp/Cafe_Bazaar_logo.svg").default,
};

export const subscriptionImages = {
  esteghlalSubscriptionLogo: require("./subscription/esteghlal-logo-2.svg")
    .default,
};
export const pollImages = {
  checkmark: require("./poll/Checkmark.svg").default,
  poll: require("./poll/poll.svg").default,
};
export const introImages = {
  intro1: require("./intro/intro1.svg").default,
  intro2: require("./intro/intro2.svg").default,
  intro3: require("./intro/intro3.svg").default,
};
export const arrowRight = require("./arrowRight.svg").default;

export const doctorImages = {
  doctor1: require("./doctor/doctor1.svg").default,
  doctor2: require("./doctor/doctor2.svg").default,
  doctor3: require("./doctor/doctor3.svg").default,
};
export const arrowNext = require("./arrowNext.svg").default;

export const kadonaImage = {
  kadonaIcon: require("./kadona/gift_icon.svg").default,
};
